import type { SRT_ColumnPinningState } from '@/shared/components/master-table'
import type { StateCreator } from 'zustand'

type ColumnsPreset = {
	id: string
	name: string
}
export type ColumnsPresetConfig = {
	columnVisibility: Record<string, boolean>
	columnPinning: SRT_ColumnPinningState
	columnOrder: string[]
	columnSizing: Record<string, number>
}
export type PresetSliceShape = {
	defaultPreset: ColumnsPresetConfig
	backupPreset: ColumnsPresetConfig | undefined
	activePreset: string
	availablePresets: ColumnsPreset[]
	setActivePreset(preset: string): void
	setAvailablePresets(presets: ColumnsPreset[]): void
	setBackupPreset(backup: ColumnsPresetConfig | undefined): void
}

export const createPresetSlice: StateCreator<PresetSliceShape> = (set) => ({
	activePreset: '__my__',
	availablePresets: [],
	backupPreset: undefined,
	defaultPreset: {
		columnVisibility: {},
		columnPinning: { left: [], right: [] },
		columnOrder: [],
		columnSizing: {},
	},
	setActivePreset: (preset) =>
		set({
			activePreset: preset,
		}),
	setAvailablePresets: (presets) =>
		set({
			availablePresets: presets,
		}),
	setBackupPreset: (backup) =>
		set({
			backupPreset: backup,
		}),
})
